<template>

<div class="tags">
     <div v-for="(item) in SelectedBuckets">
         <Tag type="border" closable size="large" @on-close="RemoveItem(item)">{{item.Name}}</Tag>
     </div>
</div>

</template>



<script>

export default {
	name: 'FilterRemoval',
    components: {  },
	props: {
		SelectedBuckets: Array
    },
    methods: {
      RemoveItem(item) {
        if (item.Type == 'bucket')
            this.$emit('BucketRemoved', item.Term);
        else if (item.Type == 'colorfamily')
            this.$emit('ColorFamilyRemoved', item.Term);
        else if (item.Type == 'search')
            this.$emit('TextSearchRemoved', item.Term);

      }  
    }
    
}

</script>

<style scoped>
.tags { text-align: center}
.tags > div { display:inline-block}
</style>

